import InputPassword from './InputPassword.vue';

// @ts-ignore
InputPassword.install = (Vue) => {
  Vue.component((InputPassword as any).options.name, InputPassword);
};

export default InputPassword;
